var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9FF",
    fillRule: "evenodd",
    d: "M7.126 6.143V4.959a4.375 4.375 0 1 1 8.75 0v1.184c1.502.045 2.42.207 3.122.789.972.807 1.228 2.172 1.74 4.903l.875 4.667c.72 3.84 1.08 5.76.03 7.025-1.049 1.265-3.002 1.265-6.91 1.265H8.27c-3.907 0-5.86 0-6.91-1.265s-.69-3.185.03-7.025l.875-4.667c.512-2.73.768-4.096 1.74-4.903.702-.582 1.62-.744 3.122-.79m1.75-1.184a2.625 2.625 0 0 1 5.25 0v1.166h-5.25zm6.672 6.9a.875.875 0 0 1 .136 1.23l-4.666 5.833a.875.875 0 0 1-1.302.072L7.382 16.66a.875.875 0 0 1 1.238-1.238l1.642 1.642 4.056-5.07a.875.875 0 0 1 1.23-.136",
    clipRule: "evenodd"
  })));
};
export default SvgShoppingBag;